import { render } from "./RetailerInviteAccept.vue?vue&type=template&id=d53db8c8&scoped=true"
import script from "./RetailerInviteAccept.vue?vue&type=script&lang=js"
export * from "./RetailerInviteAccept.vue?vue&type=script&lang=js"

import "./RetailerInviteAccept.vue?vue&type=style&index=0&id=d53db8c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53db8c8"]])

export default __exports__